import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
  }

  toggle(event) {
    event.preventDefault();
    event.stopPropagation();
    const isOpen = this.menuTarget.classList.contains("show");
    document.querySelectorAll("[data-controller='dropdown'] .dropdown-menu.show")
      .forEach(menu => menu.classList.remove("show"));
    if (!isOpen) {
      this.menuTarget.classList.add("show");
      document.addEventListener("click", this._handleOutsideClick, { once: true });
    }
  }

  _handleOutsideClick() {
    this.menuTarget.classList.remove("show");
  }
}
